import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./components/Header";

function HomePage() {
  const [cartItems, setCartItems] = useState([]);

  const products = [
    {
      id: 1,
      name: "iPhone 15 Pro 128GB",
      price: 1099.99,
      category: "Smartphones",
      rating: 4.8,
      reviews: 342,
      image: "📱",
      discount: 15,
      slug: "iphone-15-pro-128gb",
    },
    {
      id: 2,
      name: 'MacBook Air M2 13" 256GB',
      price: 1299.99,
      category: "Computadores",
      rating: 4.9,
      reviews: 189,
      image: "💻",
      discount: 10,
      slug: "macbook-air-m2-13-256gb",
    },
    {
      id: 3,
      name: 'Samsung Smart TV 65" QLED 4K',
      price: 899.99,
      category: "TVs",
      rating: 4.7,
      reviews: 156,
      image: "📺",
      discount: 20,
      slug: "samsung-smart-tv-65-qled-4k",
    },
    {
      id: 4,
      name: "AirPods Pro 2ª Geração",
      price: 249.99,
      category: "Áudio",
      rating: 4.6,
      reviews: 278,
      image: "🎧",
      discount: 12,
      slug: "airpods-pro-2a-geracao",
    },
    {
      id: 5,
      name: 'iPad Air 10.9" 64GB',
      price: 649.99,
      category: "Tablets",
      rating: 4.8,
      reviews: 203,
      image: "📱",
      discount: 8,
      slug: "ipad-air-10-9-64gb",
    },
    {
      id: 6,
      name: "Canon EOS R7 Mirrorless",
      price: 1899.99,
      category: "Fotografia",
      rating: 4.9,
      reviews: 89,
      image: "📷",
      discount: 5,
      slug: "canon-eos-r7-mirrorless",
    },
    {
      id: 7,
      name: "PlayStation 5 + 2 Comandos",
      price: 549.99,
      category: "Gaming",
      rating: 4.7,
      reviews: 445,
      image: "🎮",
      discount: 18,
      slug: "playstation-5-2-comandos",
    },
    {
      id: 8,
      name: "Nest Learning Thermostat",
      price: 199.99,
      category: "Casa Inteligente",
      rating: 4.5,
      reviews: 167,
      image: "🏠",
      discount: 25,
      slug: "nest-learning-thermostat",
    },
  ];

  const addToCart = (product) => {
    setCartItems([...cartItems, product]);
  };

  // Atualizar URL no Chatwoot quando a página carrega
  useEffect(() => {
    if (window.updateChatwootURL) {
      window.updateChatwootURL();
    }
  }, []);

  return (
    <div className="App">
      <Header />

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-background">
          <div className="hero-pattern"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h2>Inovação e Tecnologia para o Seu Dia a Dia</h2>
              <p>
                Descubra as melhores ofertas em smartphones, computadores, TVs e
                muito mais. Garantia estendida e entrega gratuita em todas as
                compras.
              </p>
              <div className="hero-features">
                <div className="hero-feature">
                  <span className="feature-icon">🚚</span>
                  <span>Entrega Grátis</span>
                </div>
                <div className="hero-feature">
                  <span className="feature-icon">🛡️</span>
                  <span>Garantia Estendida</span>
                </div>
                <div className="hero-feature">
                  <span className="feature-icon">💳</span>
                  <span>Pagamento Seguro</span>
                </div>
                <div className="hero-feature">
                  <span className="feature-icon">🏪</span>
                  <span>Lojas Próximas</span>
                </div>
              </div>
              <div className="hero-buttons">
                <button className="cta-button primary">
                  Ver Ofertas Especiais
                </button>
                <button className="cta-button secondary">Encontrar Loja</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Categories */}
      <section className="categories">
        <div className="container">
          <h3 className="section-title-blue">Categorias em Destaque</h3>
          <div className="category-grid">
            <div className="category-card">
              <div className="category-icon">📱</div>
              <h4>Smartphones</h4>
              <p>Os melhores telemóveis</p>
            </div>
            <div className="category-card">
              <div className="category-icon">💻</div>
              <h4>Computadores</h4>
              <p>Portáteis e desktops</p>
            </div>
            <div className="category-card">
              <div className="category-icon">📺</div>
              <h4>TVs</h4>
              <p>Smart TVs e acessórios</p>
            </div>
            <div className="category-card">
              <div className="category-icon">🎧</div>
              <h4>Áudio</h4>
              <p>Fones e colunas</p>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="products">
        <div className="container">
          <h3 className="section-title-blue">Produtos em Destaque</h3>
          <div className="products-grid">
            {products.map((product) => (
              <Link
                key={product.id}
                to={`/produto/${product.slug}`}
                style={{ textDecoration: "none", color: "inherit" }}
                className="product-card-link"
              >
                <div className="product-card">
                  <div className="product-image">
                    <span className="product-emoji">{product.image}</span>
                    {product.discount > 0 && (
                      <div className="discount-badge">-{product.discount}%</div>
                    )}
                  </div>
                  <div className="product-info">
                    <h4>{product.name}</h4>
                    <div className="product-category">{product.category}</div>
                    <div className="product-rating">
                      <span className="stars">
                        {"⭐".repeat(Math.floor(product.rating))}
                      </span>
                      <span className="rating-text">
                        ({product.reviews} avaliações)
                      </span>
                    </div>
                    <div className="product-price">
                      <span className="current-price">
                        {product.price.toFixed(2)}€
                      </span>
                      {product.discount > 0 && (
                        <span className="original-price">
                          {(
                            product.price /
                            (1 - product.discount / 100)
                          ).toFixed(2)}
                          €
                        </span>
                      )}
                    </div>
                    <button
                      className="add-to-cart-btn"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        addToCart(product);
                      }}
                    >
                      Adicionar ao Carrinho
                    </button>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <h3 className="section-title-blue">Porque Escolher a Kodly?</h3>
          <div className="features-grid">
            <div className="feature">
              <div className="feature-icon">🚚</div>
              <h4>Entrega Gratuita</h4>
              <p>Em compras superiores a 50€</p>
            </div>
            <div className="feature">
              <div className="feature-icon">🔄</div>
              <h4>Devolução Gratuita</h4>
              <p>30 dias para devolver</p>
            </div>
            <div className="feature">
              <div className="feature-icon">🛡️</div>
              <h4>Garantia Estendida</h4>
              <p>Até 3 anos de garantia</p>
            </div>
            <div className="feature">
              <div className="feature-icon">💳</div>
              <h4>Pagamento Seguro</h4>
              <p>Múltiplas formas de pagamento</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h4>Kodly</h4>
              <p>A sua loja de confiança em tecnologia desde 2015.</p>
              <div className="social-links">
                <a href="#facebook">📘</a>
                <a href="#instagram">📷</a>
                <a href="#twitter">🐦</a>
                <a href="#youtube">📺</a>
              </div>
            </div>

            <div className="footer-section">
              <h4>Ajuda</h4>
              <ul>
                <li>
                  <a href="#contact">Contactos</a>
                </li>
                <li>
                  <a href="#shipping">Envio e Entrega</a>
                </li>
                <li>
                  <a href="#returns">Devoluções</a>
                </li>
                <li>
                  <a href="#warranty">Garantias</a>
                </li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Empresa</h4>
              <ul>
                <li>
                  <a href="#about">Sobre Nós</a>
                </li>
                <li>
                  <a href="#careers">Carreiras</a>
                </li>
                <li>
                  <a href="#stores">Lojas</a>
                </li>
                <li>
                  <a href="#press">Imprensa</a>
                </li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Legal</h4>
              <ul>
                <li>
                  <a href="#terms">Termos e Condições</a>
                </li>
                <li>
                  <a href="#privacy">Política de Privacidade</a>
                </li>
                <li>
                  <a href="#cookies">Política de Cookies</a>
                </li>
                <li>
                  <a href="#complaints">Livro de Reclamações</a>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer-bottom">
            <p>&copy; 2025 Kodly. Todos os direitos reservados.</p>
            <p>Desde 2015, a sua loja de confiança em tecnologia</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default HomePage;
